const resume = {
  name: "Swaraj Vamsi Krishna Kanakala",
  title: "Associate Consultant",
  summary:
    "An IT professional with 5+ years of experience in RPA with UiPath, Blue Prism, Python, .NET C#, SQL/MYSQL, HTML/CSS and Core Java technologies, with exposure to AI, ML, and Cloud. Focused on providing hybrid automated solutions to optimize critical business processes and enhance productivity.",
  contact: {
    email: "swarajvamsikrishna@gmail.com",
    phone: "+91 8106723600",
    location: "Bengaluru, India",
    linkedin: "https://linkedin.com/in/swaraj-vamsi-krishna-kanakala",
    github: "https://github.com/swarajvamsikrishna",
  },
  skills: [
    "UiPath - RPA",
    "Automation Anywhere - RPA",
    "Blue Prism - RPA",
    "Python",
    ".NET C#",
    "SQL/MySQL",
    "HTML & CSS",
    "Core Java (Basic)",
    "AI / ML (Exposure)",
    "Cloud (Exposure)",
  ],
  highlights: [
    "5+ years experience in RPA & Automation",
    "Strong backend skills with Python and .NET",
    "Database design and optimization (SQL/MySQL)",
    "Developer-focused modern UI & web fundamentals",
  ],
  experience: [
    {
      role: "Consultant (UiPath - RPA)",
      company: "Ernst & Young (EY) LLP",
      duration: "11/2022 - Present",
      location: "Bengaluru & Hyderabad",
      roles: [
        "Responsible for leading a team of cross-skilled developers",
        "Bridge between business and team to maintain quality deliverables on time",
        "Conducted POCs, automation workshops, and supported upcoming developers",
      ],
    },
    {
      role: "Associate Consultant",
      company: "Capgemini",
      duration: "04/2017 - 11/2022",
      location: "Hyderabad, Mumbai & Bengaluru",
      roles: [
        "Started as a Software Associate with C#.NET",
        "Progressed through Analyst, Senior Analyst to Associate Consultant roles",
        "Worked as RPA Practitioner developing Python & UiPath automation solutions",
      ],
    },
  ],
  projects: [
    {
      client: "Santander",
      duration: "03/2022 - 08/2022",
      responsibilities: [
        "Developed and automated the overdraft process using UiPath Forms",
        "Created experimental 'Always On Process' to run multiple processes simultaneously",
      ],
    },
    {
      client: "HBSC",
      duration: "11/2021 - 03/2022",
      responsibilities: [
        "Conducted automation workshop for feasibility analysis",
        "Created POC in UiPath for client RPA adoption",
      ],
    },
    {
      client: "Tech Office",
      duration: "10/2017 - 11/2022",
      responsibilities: [
        "Conducted 20+ automation workshops to identify suitable processes",
        "Developed dashboards in ASP.NET with SQL/MySQL/Oracle for BOT monitoring",
        "Built 120+ UiPath BOTS, 70+ Python scripts, and 30+ reusable components",
      ],
    },
    {
      client: "Bayer",
      duration: "11/2017 - 11/2022",
      responsibilities: [
        "UiPath: Image-based SAP automation on VDI (60+ processes, 24/7) saving 2 FTE",
        "Python: Breached Ticket SLA Analyzer, saving 7 days per month",
      ],
    },
    {
      client: "Solvay",
      duration: "07/2018 - 11/2022",
      responsibilities: [
        "Python: URL Monitoring & PDF Data Extraction, increased processing efficiency to 90%",
        "Twilio: Automated calling and text messaging alerts",
      ],
    },
    {
      client: "IKEA",
      duration: "12/2018 - 11/2022",
      responsibilities: [
        "UiPath: Image-based VDI applications, Furniture Resizer app, saving 1.5 FTE",
        "Python: BMC Remedy Web API & ticket automation, saving 1 FTE",
        "NICE: Desktop application automation",
      ],
    },
    {
      client: "Inex",
      duration: "04/2019 - 11/2022",
      responsibilities: [
        "UiPath: SAP & ServiceNow automation",
        "Python: ServiceNow ticket dispatching and SLA monitoring",
        "Twilio: Automated calling & SMS notifications",
      ],
    },
    {
      client: "Action",
      duration: "08/2020 - 11/2022",
      responsibilities: [
        "UiPath - SAP Desktop Automation for missing deliveries",
        "Python - URL & Server Health Check Monitoring, saving 240 mins/day",
      ],
    },
    {
      client: "Fiskars",
      duration: "02/2020 - Present",
      responsibilities: [
        "Python - ServiceNow Automatic Ticket Creation via API",
        "Tickets assigned to groups/persons based on roster, preventing SLA breaches and fines",
      ],
    },
    {
      client: "A-Star",
      duration: "07/2021 - 11/2022",
      responsibilities: [
        "Python - Excel Reports Automation: downloading, reformatting, collating, calculating, and sending via email",
        "Saved ~600 hours/month",
      ],
    },
    {
      client: "Neste",
      duration: "09/2020 - 08/2021",
      responsibilities: [
        "UiPath - Invoice Processing Image-Based Automation",
        "Complex daily process automation, saving 2 hours/day",
      ],
    },
    {
      client: "Schneider",
      duration: "01/2020 - 03/2020",
      responsibilities: [
        "UiPath - Citrix Automation of Portal Monitoring, saving 0.5 FTE",
        "Python - Mailbox Monitoring, organizing mailbox, ticket creation, replies, and forwarding",
      ],
    },
    {
      client: "Postnord",
      duration: "04/2019 - 08/2019",
      responsibilities: [
        "UiPath - Maintenance of 200+ Desktop and Citrix pre-developed scripts",
        "Orchestrator: Maintaining queues, processes, BOTs",
      ],
    },
    {
      client: "DeLaval",
      duration: "02/2019 - 10/2019",
      responsibilities: [
        "UiPath - Image-Based Automation on Internal Portal",
        "Web Browser Automation: ServiceNow report extraction & mail distribution",
      ],
    },
    {
      client: "Yara Prisma",
      duration: "02/2019 - 08/2019",
      responsibilities: [
        "UiPath - SAP Desktop & Image-Based Automation on VDIs",
        "Python - URL Monitoring & Server Health Check alerts",
      ],
    },
    {
      client: "BMW",
      duration: "12/2018 - 12/2020",
      responsibilities: [
        "UiPath - SAP Desktop, Internal Desktop, BMC Remedy & Password Reset Automation",
        "Python - Oracle DB report extraction & mail alerts",
      ],
    },
    {
      client: "IKANO",
      duration: "10/2018 - 03/2019",
      responsibilities: [
        "UiPath - Control-M Desktop & Internal App Image-Based Automation",
        "Python - Log parsing and email alerts",
      ],
    },
    {
      client: "Ruokakesko",
      duration: "08/2019 - 01/2021",
      responsibilities: [
        "UiPath - 80+ Bots for SAP Desktop, SAP Image, Web Browser Automation",
        ".NET Dashboard - BOT execution monitoring",
      ],
    },
    {
      client: "Canon",
      duration: "08/2018 - 08/2021",
      responsibilities: [
        "UiPath - Maintenance of 150+ BOTs in RE Framework and Canon Custom Framework",
        "Managing Test/Dev/Prod instances of Orchestrator",
      ],
    },
    {
      client: "MHC",
      duration: "06/2018 - 08/2020",
      responsibilities: [
        "UiPath - ServiceNow Web Browser Automation",
        "Python - Mailbox Monitoring, ServiceNow SOAP & Web API Automation",
      ],
    },
    {
      client: "Posten",
      duration: "03/2018 - 05/2018",
      responsibilities: [
        "UiPath - Image-Based Automation of AS400 Mainframe systems",
        "Python - SVN Auto commit & File Updating",
        "CMD - File Transfer from Windows to Linux Server",
      ],
    },
    {
      client: "Atlas Copco",
      duration: "02/2018 - 01/2019",
      responsibilities: [
        "UiPath - SAP Desktop Automation for PO/GR/IDOC & Billing issues",
        "20+ UiPath Bots developed, saving ~3 hours/day",
      ],
    },
    {
      client: "CNHI",
      duration: "02/2018 - 04/2018",
      responsibilities: [
        "Python - Log Parsing to reduce human errors and increase accuracy to 98%",
      ],
    },
    {
      client: "Friesland Campina",
      duration: "01/2018 - 06/2021",
      responsibilities: [
        "UiPath - SAP Image-Based Automation in Citrix VDIs",
        "15+ Bots developed for delivery issue resolution",
      ],
    },
    {
      client: "ALE",
      duration: "02/2018 - 08/2018",
      responsibilities: [
        "UiPath - SAP Desktop Automation for IDOC cleanups",
        "Reduced manual effort by 1.5hrs/day",
      ],
    },
    {
      client: "Cargill",
      duration: "12/2017 - 08/2019",
      responsibilities: [
        "UiPath - SAP Desktop Automation analyzing Sales Order failures",
      ],
    }
  ],
  certifications: [
    "UiPath - Advanced RPA Developer",
    "Capgemini - Automation Engineer",
    "Capgemini - Automation Practitioner",
    "Coursera - AI & ML Basics",
    "Coursera - Agile Software Development",
    "Microsoft - Azure Fundamentals AZ900",
    "NICE - Junior Developer",
    "UiPath - Orchestrator",
    "UiPath - SAP Automation",
  ],
  education: [
    {
      degree: "MBA",
      institution: "Annamalai University",
      duration: "05/2019 - 05/2021",
      grade: "75%",
      courses: ["E-Business"],
    },
    {
      degree: "Bachelor of Computer Science",
      institution: "Aditya Degree College - Andhra University",
      duration: "04/2014 - 04/2017",
      grade: "8.5 GPA",
      courses: ["Computer Science", "Maths", "Physics"],
    },
  ],
  achievements: [
    "Dropbox Activities Publication: 800+ developers downloaded worldwide",
    "FTE Savings: 15+ FTE saved, 5+ FTE in last year",
    "Best Developer: EAMS Highlights 2021 & 2019",
    "Project Star: Awards for 2020 & 2018",
    "Promotions: 4 times with top ratings",
    "Trained 20+ Young Professionals in RPA & Python",
  ],
  softSkills: [
    "Teamwork",
    "Dependability",
    "Adaptability & Flexibility",
    "Multitasking & Problem Solving",
  ],
  references: [
    {
      name: "Atul Bharate",
      role: "Sr. Manager at Capgemini",
      email: "atul.bharate@gmail.com",
      phone: "9867169495",
    },
    {
      name: "Sonal Patil",
      role: "Associate Consultant at Capgemini",
      email: "patil3420@gmail.com",
      phone: "9594253160",
    },
  ],
  interests: ["Cooking", "Swimming", "Netflix", "Travelling", "Gaming", "Teaching"],
};

export default resume;
